module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<li>\r\n    <!-- id="item-list'+
((__t=( val.code ))==null?'':__t)+
'" -->\r\n    <input id="item-list-'+
((__t=(name))==null?'':__t)+
'-'+
((__t=( val.codeFormat ))==null?'':__t)+
'" type="checkbox" value="'+
((__t=( val.code ))==null?'':__t)+
'" class="'+
((__t=(name))==null?'':__t)+
' phx-list-box-item"/> \r\n    <label for="item-list-'+
((__t=(name))==null?'':__t)+
'-'+
((__t=( val.codeFormat ))==null?'':__t)+
'" class="phx-list-box-item-label">'+
((__t=( val.libelle ))==null?'':__t)+
'</label>\r\n</li>';
}
return __p;
};
